import React from "react";

const IconEasing: React.FC = () => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 66.9 73.66"
      stroke="currentColor"
      strokeWidth={6}
    >
      <path
        className="cls-1"
        d="m50.37,63.9c0,3.74,3.03,6.77,6.77,6.77s6.77-3.03,6.77-6.77-3.03-6.77-6.77-6.77-6.77,3.03-6.77,6.77Zm0,0h-6.77M16.53,9.77c0,3.74-3.03,6.77-6.77,6.77s-6.77-3.03-6.77-6.77,3.03-6.77,6.77-6.77,6.77,3.03,6.77,6.77Zm0,0h6.77m16.92,0h-6.77m0,54.13h-6.77m-23.68,0c27.07,0,33.83-54.13,60.9-54.13"
      />
    </svg>
  );
};

export default IconEasing;
